import { styled } from 'baseui'
import { FlexColumn, FlexBetween } from '@/shared/theme/styled-components'

export const StyledContainer = styled(FlexColumn, {
  width: '100%',
  padding: '1rem',
  paddingBottom: '0.4rem',
  gap: '1rem',
})

export const StyledTitleWrapped = styled('h3', ({ $theme }) => ({
  flexGrow: 1,
  margin: 0,
  color: $theme.colors.primary,
  ...$theme.typography.HeadingXSmall,
  fontSize: '1.5rem',
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
}))

export const HeaderContainer = styled(FlexBetween, {
  width: '100%',
})

export const StyledTitle = styled('h3', ({ $theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontWeight: '600',
  fontSize: '1.125rem',
  lineHeight: '160%',
  color: $theme.colors.textHeading,
}))

export const ChangeUserContainer = styled('div', {
  width: '100%',
  display: 'flex',
})
